module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iQWDrF/tc-custom/9781398439597.jpg?1705688258846",
      "alt": "This image is the cover for the book The Unluckiest Boy in the World"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Unluckiest Boy in the World\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("George never seems to be very lucky. Nothing ever seems to go quite right for him. In fact, George believes that he is the unluckiest boy in the world. When his class is involved in a school project involving growing sunflowers and the production of a play called “James and The Giant Sunflower”, which is to be performed in front of all the parents at the summer fair, things seem to go from bad to worse for George. Will he ever be able to beat Ben – good at everything and always the first with his hand up in class? How does Mr. Greenwood, the school caretaker, get involved in George’s fortunes? Will George’s luck ever change?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Aldcroft\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in Cheshire, but brought up in Kent, Helen returned to her Northern roots to study English Language and Literature at Manchester University. She went on to take a post graduate teaching qualification. After 23 enjoyable and successful years as a primary school teacher and deputy head teacher, Helen was able to take the time and opportunity to follow other interests, including writing. Helen lives with her husband Steve, their two dogs and four chickens close to the Saddleworth Hills of East Lancashire enjoying walking, gardening, crafting and is an active member of her local WI.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0